import { ref } from 'vue'

export class SchedulerDialogViewModel
{
    opened = ref(false)

    show()
    {
        this.opened.value = true
    }

    close()
    {
        this.opened.value = false
    }
}